import { z } from "zod";

import { DatabaseAuditRecord, DatabaseIdentity, DatabaseSystemRecord } from "@/core/api";
import { Coordinates } from "@/data/types/Coordinates";

export const LegalEntity = z
  .object({
    name: z.string(),
    country: z.string(),
    city: z.string(),
    zipCode: z.string(),
    street: z.string(),
    phoneNumber: z.string(),
    headquarter: z.boolean(),
    coordinates: Coordinates,
    logoPublicUrl: z.string().nullish(),
  })
  .merge(DatabaseIdentity)
  .merge(DatabaseSystemRecord)
  .merge(DatabaseAuditRecord)
  .passthrough();

export type LegalEntity = z.infer<typeof LegalEntity>;
